import request from "../../utils/request";

export function doCreateLocation(params) {
  return request("/locations", {
    method: "POST",
    data: params,
  });
}

export function doUpdateLocation(params) {
  return request(`/locations/${params.id}`, {
    method: "PUT",
    data: params,
  });
}

export function doDetailLocation(id) {
  return request(`/locations/${id}`, {
    method: "GET",
  });
}

export function doDeleteLocation(id) {
  return request(`/locations/${id}`, {
    method: "DELETE",
  });
}
